//src/App/Main/RouteCategory.js
module.exports = {
    
    CREATE: {
        BRANCH: ["/api/create-branch"],
        CUSTOMER_BALANCE: ["/api/add-customer-balance"],
        CUSTOMER: ["/api/create-customer"],
        EXPENSE_CATEGORY: ["/api/create-expense-category"],
        EXPENSE: ["/api/create-expense"],
        INVENTORY: ["/api/create-inventory"],
        INVENTORY_IMPORT: ["/api/create-inventories-csv"],
        INVOICES: ["/api/create-invoice"],
        PRODUCTS: ["/api/create-product"],
        PRODUCT_IMPORT_TO_SUB_BRANCH: ["/api/create-bulk-product"],
        PRODUCT_IMPORT: ["/api/create-products-csv"],
        PRODUCT_BRANDS: ["/api/create-product-brand"],
        PRODUCT_CATEGORY: ["/api/create-product-category"],
        PRODUCT_UNIT: ["/api/create-product-unit"],
        PURCHASE_ORDER: ["/api/create-purchase-order"],
        PURHCASE_RETURNS: ["/api/create-purchases-return"],
        RECEIVED: ["/api/create-receive"],
        REFERENCE: ["/api/create-reference"],
        REQUEST: ["/api/create-request"],
        ROLE: ["/api/create-role"],
        SALES_RETURN: ["/api/create-sales-return"],
        SUPPLIERS: ["/api/create-supplier"],
        TRANSFER: ["/api/create-transfer"],
        USER: ["/api/signup", "/api/create-user"]
    },

    UPDATE: {
        BRANCH: ["/api/update-branch"],
        CUSTOMER: ["/api/update-customer"],
        EXPENSE_CATEGORY: ["/api/update-expense-category"],
        EXPENSE: ["/api/update-expense"],
        INVENTORY: ["/api/update-inventory"],
        INVOICES: ["/api/update-invoice"],
        PRODUCTS: ["/api/update-product"],
        PRODUCT_BRANDS: ["/api/update-product-brand"],
        PRODUCT_CATEGORY: ["/api/update-product-category"],
        PRODUCT_UNIT: ["/api/update-product-unit"],
        PURCHASE_ORDER: ["/api/update-purchase-order"],
        PURHCASE_RETURNS: ["/api/update-purchases-return"],
        RECEIVED: ["/api/update-receive"],
        REFERENCE: ["/api/update-reference"],
        REQUEST: ["/api/update-request"],
        ROLE: ["/api/update-role"],
        SALES_RETURN: ["/api/update-sales-return"],
        SUPPLIERS: ["/api/update-supplier"],
        TRANSFER: ["/api/update-transfer"],
        USER: ["/api/update-user", "/api/update-user-auth"]
    },

    DELETE: {
        BRANCH: ["/api/delete-branch"],
        CUSTOMER: ["/api/delete-customer"],
        EXPENSE_CATEGORY: ["/api/delete-expense-category"],
        EXPENSE: ["/api/delete-expense"],
        INVENTORY: ["/api/delete-inventory", "/api/delete_all_expired_inventories", "/api/delete_multiple_inventories"],
        INVOICES: ["/api/delete-invoice"],
        PRODUCTS: ["/api/delete-product"],
        PRODUCT_BRANDS: ["/api/delete-product-brand"],
        PRODUCT_CATEGORY: ["/api/delete-product-category"],
        PRODUCT_UNIT: ["/api/delete-product-unit"],
        PURCHASE_ORDER: ["/api/delete-purchase-order"],
        PURHCASE_RETURNS: ["/api/delete-purchases-return"],
        RECEIVED: ["/api/delete-receive"],
        REFERENCE: ["/api/delete-reference"],
        REQUEST: ["/api/delete-request"],
        ROLE: ["/api/delete-role"],
        SALES_RETURN: ["/api/delete-sales-return"],
        SUPPLIERS: ["/api/delete-supplier"],
        TRANSFER: ["/api/delete-transfer"],
        USER: ["/api/delete-user"]
    },

    GET_SINGLE: {
        BRANCH: ["/api/get-branch"],
        CUSTOMER: ["/api/get-customer"],
        EXPENSE_CATEGORY: ["/api/get-expense-category"],
        EXPENSE: ["/api/get-expense"],
        INVENTORY: ["/api/get-inventory", "/api/get-inventory-barcode"],
        INVOICES: ["/api/get-invoice"],
        PRODUCTS: ["/api/get-product", "/api/get-product-name", "/api/get-product-barcode"],
        PRODUCT_BRANDS: ["/api/get-product-brand"],
        PRODUCT_CATEGORY: ["/api/get-product-category"],
        PRODUCT_UNIT: ["/api/get-product-unit"],
        PURCHASE_ORDER: ["/api/get-purchase-order"],
        PURHCASE_RETURNS: ["/api/get-purchases-return"],
        RECEIVED: ["/api/get-receive"],
        REFERENCE: ["/api/get-reference"],
        REQUEST: ["/api/get-request"],
        ROLE: ["/api/get-role"],
        SALES_RETURN: ["/api/get-sales-return"],
        SUPPLIERS: ["/api/get-supplier/:id"],
        TRANSFER: ["/api/get-transfer"],
        USER: ["/api/get-user", "/api/get-user-auth"]
    },

    GET_ALL: {
        BRANCH: ["/api/get-all-branches", "/api/get-all-sub-branches"],
        CUSTOMER: ["/api/get-all-customers"],
        EXPENSE_CATEGORY: ["/api/get-all-expense-categories"],
        EXPENSE: ["/api/get-all-expenses"],
        INVENTORY: ["/api/get-all-inventories"],
        INVOICES: ["/api/get-all-invoices", "/api/get-all-invoices-details", "/api/get-all-invoice-details"],
        PRODUCTS: ["/api/get-all-products", "/api/get-all-unavailable-products"],
        PRODUCT_BRANDS: ["/api/get-all-product-brands"],
        PRODUCT_CATEGORY: ["/api/get-all-product-categories"],
        PRODUCT_UNIT: ["/api/get-all-product-units"],
        PURCHASE_ORDER: ["/api/get-all-purchase-orders", "/api/get-all-purchases-details", "/api/get-all-purchase-details"],
        PURHCASE_RETURNS: ["/api/get-all-purchases-returns", "/api/get-all-purchases_-eturns-details", "/api/get-all-purchases-return-details"],
        RECEIVED: ["/api/get-all-received", "/api/get-all-received-ids"],
        REFERENCE: ["/api/get-all-references"],
        REQUEST: ["/api/get-all-requests", "/api/get-all-requested"],
        ROLE: ["/api/get-all-roles"],
        SALES_RETURN: ["/api/get-all-sales-returns", "/api/get-all-sales_-eturns-details", "/api/get-all-sales-return-details"],
        SUPPLIERS: ["/api/get-all-suppliers"],
        TRANSFER: ["/api/get-all-transfers", "/api/get-all-purchases_-eturns-details", "/api/get-all-transfer-details"],
        USER: ["/api/get-all-users"]
    },

    GET_LOGS: {
        BRANCH: ["/api/get-branch-log", "/api/get-all-branches-log"],
        CUSTOMER: ["/api/get-all-customers-log"],
        CUSTOMER_BALANCE: ["/api/get-customer-balance-logs", "/api/get-customer-balance-summary"],
        EXPENSE_CATEGORY: ["/api/get-expense-category-log", "/api/get-all-expense-categories-log"],
        EXPENSE: ["/api/get-expense-log", "/api/get-all-expenses-log"],
        INVENTORY: ["/api/get_inventory_log", "/api/get_all_inventories_log"],
        INVOICES: ["/api/get-invoice-log", "/api/get-all-invoices-log"],
        PRODUCTS: ["/api/get_product_log", "/api/get_all_products_log"],
        PRODUCT_BRANDS: ["/api/get-product-brand-log", "/api/get-all-product-brand-logs"],
        PRODUCT_CATEGORY: ["/api/get-product-category-log", "/api/get-all-product-category-logs"],
        PRODUCT_UNIT: ["/api/get-product-unit-log", "/api/get-all-product-unit-logs"],
        PURCHASE_ORDER: ["/api/get-purchase-log", "/api/get-all-purchases-log"],
        PURHCASE_RETURNS: ["/api/get-purchases-return-log", "/api/get-all-purchases-returns-log"],
        RECEIVED: ["/api/get-purchase-log", "/api/get-all-purchases-log"],
        ROLE: ["/api/get-role-log", "/api/get-all-role-logs"],
        SALES_RETURN: ["/api/get-sales-return-log", "/api/get-all-sales-returns-log"],
        SUPPLIERS: ["/api/get-supplier-log", "/api/get-all-suppliers-log"],
        TRANSFER: ["/api/get-transfer-log", "/api/get-all-transfers-log"],
        USER: ["/api/get-user-log/:id", "/api/get-all-user-logs/:user"]
    },

    GET_REPORTS: {
        DASHBOARD: [
            "/api/get-dashboard",
            "/api/get-all-products-reports",
            "/api/get-all-products-low-reports",
            "/api/get-all-products-out-of-stock-reports",
            "/api/get-all-inventories-reports",
            "/api/get-all-inventories-near-expiry-reports",
            "/api/get-all-inventories-expired-reports",
            "/api/get-purchase-return-reports",
            "/api/get-sales-reports",
            "/api/get-purchase-reports",
            "/api/get-fast-moving-products-reports",
            "/api/get-products-ageing-reports",
            "/api/get-products-received-ageing-reports",
            "/api/get-net-sales-reports",
            "/api/get-sales-tax-reports",
            "/api/get-purchase-tax-reports",
            "/api/get-vat-summary-report",
            "/api/get-transfers-reports"
        ],
        DOWNLOADS: [
            "/api/download-inventory-csv",
            "/api/download-all-products-reports-csv"
        ]
    },

    AUTH: {
        BRANCH: ["/api/get-auth-branch"],
        USER: ["/api/send-otp", "/api/signin", "/api/signout"]
    },

    GET_DETAILS: {
        PURCHASE_ORDER: ["/api/get-purchase-order-inventories"],
        RECEIVED: ["/api/get-receive-inventories"],
        REQUEST: ["/api/get-request-inventories"]
    }

};